import type { SortingState } from '@tanstack/react-table';
import { RxFilterValues } from '../../types';
import { TableNullStateType } from '../TableNullState/TableNullState';
import { OverallStatusFilter } from '../../api';
export interface RxSortParams {
  // the column that the table is sorted by
  sort_by?: string;
  // whether the column is sorted in descending order
  sort_desc: boolean;
}

export const getRxSortParams = (sorting: SortingState): RxSortParams => {
  const columnId = sorting[0]?.id;
  let sort_by: string | undefined;
  // some column ids don't make the sorting name, so we need to convert them
  switch (columnId) {
    case 'patient_info':
      sort_by = 'patient_name';
      break;
    case 'prescription_recieved_at':
      sort_by = 'created_at';
      break;
    default:
      // "prescriber_name", "drug_name"
      sort_by = columnId;
  }
  const sort_desc = sorting[0]?.desc ?? true;
  return { sort_by, sort_desc };
};

// NOTE: sort_by and sort_desc are strings because they come from the URL params
export const getRxSortingState = (sort_by: string | null, sort_desc: string | null): SortingState => {
  let columnId = 'prescription_recieved_at';
  // some column ids don't make the sorting name, so we need to convert them
  switch (sort_by) {
    case 'patient_name':
      columnId = 'patient_info';
      break;
    case 'created_at':
      columnId = 'prescription_recieved_at';
      break;
    default:
      // "prescriber_name", "drug_name"
      if (sort_by) {
        columnId = sort_by;
      }
  }
  return [
    {
      id: columnId,
      desc: sort_desc !== 'false',
    },
  ];
};

export const getRxTableNullStateType = (
  initialFilterValues?: RxFilterValues,
  searchValue?: string,
  hasAnyPrescriptions?: boolean,
) => {
  // If the practice has never had any prescriptions, show the first-time empty state
  if (hasAnyPrescriptions === false) {
    return TableNullStateType.NO_PRESCRIPTIONS_EVER;
  }

  // Check if there's a search value applied
  if (searchValue && searchValue !== '') {
    return TableNullStateType.NO_RESULTS_FROM_SEARCH;
  }

  if (
    !!initialFilterValues?.office ||
    !!initialFilterValues?.prescriber ||
    !!initialFilterValues?.drug ||
    !!initialFilterValues?.drug_category ||
    !!initialFilterValues?.status ||
    !!initialFilterValues?.startDate ||
    !!initialFilterValues?.endDate
  ) {
    return TableNullStateType.NO_RESULTS_FROM_FILTERS;
  }
  if (initialFilterValues?.awaitingOffice) {
    return TableNullStateType.NO_PRESCRIPTIONS_AWAITING_OFFICE;
  }
  if (initialFilterValues?.awaitingPatient) {
    return TableNullStateType.NO_PRESCRIPTIONS_AWAITING_PATIENT;
  }
  if (initialFilterValues?.overallStatus === OverallStatusFilter.Completed) {
    return TableNullStateType.NO_PRESCRIPTIONS_COMPLETED;
  }
  return TableNullStateType.NO_PRESCRIPTIONS_OPEN;
};
